import { Play, Pause, Loader2 } from "lucide-react";
import { usePlayer, fmtTime } from "../context/PlayerContext";

export default function AudioPlayer() {
  const { current, isPlaying, position, duration, loading, toggle, seek } = usePlayer();
  if (!current) return null;

  const pct = duration ? (position / duration) * 100 : 0;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 glass border-t" data-testid="audio-player">
      <div
        className="h-[3px] bg-white/10 cursor-pointer group"
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          seek(((e.clientX - rect.left) / rect.width) * duration);
        }}
        data-testid="player-progress"
      >
        <div className="h-full bg-primary relative" style={{ width: `${pct}%` }}>
          <span className="absolute right-0 top-1/2 -translate-y-1/2 h-2.5 w-2.5 rounded-full bg-gold opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-4">
        <div className="h-11 w-11 rounded-md overflow-hidden bg-secondary shrink-0">
          {current.cover ? (
            <img src={current.cover} alt="" className="h-full w-full object-cover" />
          ) : null}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium truncate">{current.episode.title}</p>
          <p className="text-xs text-muted-foreground truncate">{current.storyTitle}</p>
        </div>
        <span className="text-xs text-muted-foreground tabular-nums hidden sm:block">
          {fmtTime(position)} / {fmtTime(duration)}
        </span>
        <button
          data-testid="player-toggle"
          onClick={toggle}
          className="h-11 w-11 rounded-full bg-primary hover:bg-primary/90 flex items-center justify-center shadow-[0_0_15px_rgba(155,27,48,0.4)] transition-colors duration-300 shrink-0"
        >
          {loading ? (
            <Loader2 size={18} className="animate-spin" />
          ) : isPlaying ? (
            <Pause size={18} fill="currentColor" />
          ) : (
            <Play size={18} fill="currentColor" className="ml-0.5" />
          )}
        </button>
      </div>
    </div>
  );
}
